import { Navigate,Outlet } from "react-router-dom"
import { useAuth } from "./AuthContext"
function ProtectedAdmin(){
    const {user}=useAuth()
    if(user?.type_compte==="Admin" && !user?.ecole){
        return <Navigate to="/ecole/insertion" replace />
    }
    return  <Outlet />
}
export default ProtectedAdmin